import { AppLookupResponse } from './../../../../shared/models/app-lookup-response';
import { MultiSelectConfigHelper } from './../../../../shared/helpers/multi-select.config';
import { Component, HostListener, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { UiStateStore } from '../../../../shared/store/ui-state-store.service';
import { Profile } from '../../../../shared/models/profile';
import { DataService } from '../../../services/data.service';
import { AppStore } from '../../../../shared/store/lookup-store.service';
import { CandidateStore } from '../../../store/candidate-store';
import { UploadStatus } from '../../../../shared/models/upload-status';
import { ImageCroppperResponse } from '../../../../shared/models/image-cropper-resp';
import { YearCount } from '../../../../shared/models/year-count';
import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs/internal/observable/of';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dashboard-candidate-profile',
  templateUrl: './dashboard-profile.component.html',
  styleUrls: ['./dashboard-profile.component.scss'],
})
export class DashboardCandidateProfileComponent implements OnInit {
  urlRegex: string =
    '/^(?:(?:(?:https?|ftp):)?//)(?:S+(?::S*)?@)?(?:(?!(?:10|127)(?:.d{1,3}){3})(?!(?:169.254|192.168)(?:.d{1,3}){2})(?!172.(?:1[6-9]|2d|3[0-1])(?:.d{1,3}){2})(?:[1-9]d?|1dd|2[01]d|22[0-3])(?:.(?:1?d{1,2}|2[0-4]d|25[0-5])){2}(?:.(?:[1-9]d?|1dd|2[0-4]d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:.(?:[a-z\u00a1-\uffff]{2,})))(?::d{2,5})?(?:[/?#]S*)?$/i';
  accountId: string;
  userProfile: Profile;
  uploadStatus: string;
  experienceYears: YearCount[] = [];

  form: FormGroup;
  languageddlSettings = MultiSelectConfigHelper.getSettings('id', 'name');
  languagesList: AppLookupResponse[] = [];
  selectedLanguages: AppLookupResponse[] = [];
  dropdownSettings = {};
  isDirtyForm: boolean;
  maxDOB: NgbDateStruct;
  minDOB: NgbDateStruct;
  isSaved: boolean;
  disabled: boolean;
  selectedValues: AppLookupResponse[] = [];
  selectAll: boolean;
  currentDate: Date = new Date();
  compareWith(item, selected) {
    return item.id === selected.id;
  }
  get languages() {
    return this.form.get('languages');
  }
  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    public uiState: UiStateStore,
    public dataService: DataService,
    public dashboardState: CandidateStore,
    public lookupStore: AppStore
  ) {
    this.experienceYears = YearCount.list();
    this.uiState.authenticatedUser.subscribe((user) => {
      if (!user) {
        return;
      }
      this.accountId = user.accountId;
    });

    this.dashboardState.profilePhoto.subscribe((pp) => {
      if (!pp || !this.form) {
        return;
      }

      this.form.patchValue({ photoPath: pp });
    });

    this.lookupStore.languages$.subscribe((resp) => {
      if (resp.length > 0) {
        this.languagesList = resp;
      }
    });

    this.maxDOB = {
      year: this.currentDate.getFullYear() - 18,
      month: this.currentDate.getMonth() + 1,
      day: this.currentDate.getDate(),
    };

    this.minDOB = {
      year: this.currentDate.getFullYear() - 70,
      month: this.currentDate.getMonth() + 1,
      day: this.currentDate.getDate(),
    }
  }

  @HostListener('window:beforeunload')
  checkCanDeactivate(): Observable<boolean> | boolean {
    return this.canDeactivate();
  }
  ngOnInit() {
    if (!this.accountId) {
      return;
    }
    this.form = this.formBuilder.group({
      id: [''],
      accountId: [`${this.accountId}`],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      phone: [
        '',
        [Validators.required, Validators.pattern('^\\+{0,1}[0-9]{11,14}$')],
      ],
      email: [
        '',
        [
          Validators.required,
          Validators.pattern(
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          ),
        ],
      ],
      sector: [''],
      dob: [''],
      gender: ['', Validators.required],
      title: ['', Validators.required],
      salary: ['', [Validators.pattern('^[0-9]+$')]],
      salaryType: [''],
      description: [''],
      facebookLink: [
        '',
        [
          Validators.pattern(
            /(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/g
          ),
        ],
      ],
      twitterLink: [
        '',
        [
          Validators.pattern(
            /(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/g
          ),
        ],
      ],
      linkedinLink: [
        '',
        [Validators.pattern('https://[a-z]+.linkedin.com/in/.*')],
      ],
      address: ['', Validators.required],
      city: ['', Validators.required],
      country: ['', Validators.required],
      photoPath: [''],
      experience: ['', Validators.required],
      educationLevel: ['', Validators.required],
      languages: [0, Validators.required], // Default model
    });
    this.dashboardState.userProfile.subscribe((up) => {
      if (!up) {
        return;
      }

      let dob = {
        year: up.dob?.getFullYear(),
        month: up.dob?.getMonth(),
        day: up.dob?.getDate(),
      };

      this.userProfile = up;
      this.selectedLanguages = this.userProfile.languages;
      this.form.patchValue({
        id: this.userProfile.id,
        firstName: this.userProfile.firstName,
        lastName: this.userProfile.lastName,
        phone: this.userProfile.phone,
        email: this.userProfile.email,
        sector: this.userProfile.sector,
        dob: dob.year ? dob: null,
        gender: this.userProfile.gender,
        title: this.userProfile.title,
        salary: this.userProfile.salary,
        salaryType: this.userProfile.salaryType,
        description: this.userProfile.description,
        facebookLink: this.userProfile.facebookLink,
        twitterLink: this.userProfile.twitterLink,
        linkedinLink: this.userProfile.linkedinLink,
        address: this.userProfile.address,
        city: this.userProfile.city,
        country: this.userProfile.country,
        languages: this.userProfile.languages, // Default model
        experience: this.userProfile.experience,
        educationLevel: this.userProfile.educationLevel,
      });
    });

    this.dataService.getProfile(this.accountId).subscribe(
      (res) => {},
      (err) => {}
    );
    // this.onCreateGroupFormValueChange();
  }

  public onSelectAll() {
    const selected = this.languagesList.map((item) => item);
    this.languages?.patchValue(selected);
  }

  onClearAll() {
    this.languages?.patchValue([]);
    this.selectAll = false;
  }
  toggleCheckAll(event: any) {
    event.stopPropagation();
    if (event.currentTarget.checked) {
      this.onSelectAll();
    } else {
      this.onClearAll();
    }
  }

  onSelectionChange(selectedItems) {
    const newList = selectedItems.map((x) => x);
    this.selectedValues = [...newList];
    this.languages?.patchValue(this.selectedValues);
    this.selectAll = this.languagesList.length == this.selectedValues.length;
  }

  writeValue(obj: any): void {
    this.selectAll = this.languagesList.length == this.selectedLanguages.length;
  }

  saveProfile(): void {
    if (!this.form.valid) {
      return;
    }
    this.dataService.saveProfile(Profile.parseForm(this.form)).subscribe(
      (res) => {
        this.isSaved = true;
        this.form.reset(this.form.value);
        this.form.markAsPristine();
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
        setTimeout(() => {
          this.router.navigate(['/candidate/resume']);
        }, 2000);
      },
      (err) => {}
    );
  }

  uploadFinished(status: UploadStatus): void {
    this.uploadStatus = status.status;
    setTimeout(() => {
      this.uploadStatus = '';
    }, 500);
    this.dashboardState.setProfilePath(status.filePath);
    this.form.markAsDirty();
  }

  handleFileChangeEvent = async (response: ImageCroppperResponse) => {
    if (!response.filePath) {
      this.uploadStatus = 'Unable to upload the file.';
      return false;
    }
    this.dashboardState.setProfilePath(response.filePath);
    this.form.markAsDirty();
  };

  canDeactivate = (): Observable<boolean> | boolean => {
    if (!this.isSaved && this.form.dirty) {
      const result = window.confirm(
        'There are unsaved changes in profile ! Are you sure want to discrad?'
      );
      return of(result);
    }
    return of(true);
  };
}
